import React, { useEffect, useRef } from 'react';
import useKeypress from '../hooks/useKeyPress';

export const VideoModal = ({ open, setter, src }) => {
  const vid = useRef();
  const openClass = open ? '' : ' opacity-0 pointer-events-none ';
  const toggleModal = () => {
    setter(!open);
  };
  useEffect(() => {
    if (src) {
      if (open) {
        vid.current.load();
        vid.current.play();
      } else {
        vid.current.pause();
      }
    }
  }, [open, src]);

  useKeypress(['Escape', 'Esc'], () => {
    if (open) {
      toggleModal();
    }
  });

  return (
    <div className={`modal fixed w-full h-full top-0 left-0 flex items-center z-50 justify-center${openClass}`}>
      <div onClick={toggleModal} className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50" />

      <div className="modal-container bg-white w-11/12 lg:w-9/12 mx-auto shadow-lg z-50 overflow-y-auto">

        <div onClick={toggleModal} className="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
          <svg className="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
          </svg>
          <span className="text-sm">(Esc)</span>
        </div>

        <div className="modal-content py-4 text-left px-6">
          <div className="flex justify-between items-center pb-3">
            <p className="text-2xl font-bold" />
            <div onClick={toggleModal} className="modal-close cursor-pointer z-50">
              <svg className="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
              </svg>
            </div>
          </div>

          <video className="w-full" ref={vid} controls>
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

        </div>
      </div>
    </div>
  );
};
